import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { IssuerWithInsiderTradingPlans } from "../../../api/models/issuer-with-insider-trading-plans";
import { DialogService } from "primeng/dynamicdialog";
import { InsiderTradingPlansService } from "../../../api/services/insider-trading-plans.service";
import { MessageService } from "primeng/api";
import { InsiderTradingPlansFilters } from "../../../api/models/insider-trading-plans-filters";
import { InsiderTradingPlans } from "../../../api/models/insider-trading-plans";
import { Router } from "@angular/router";
import { AsReportedSecurityBreakdownTags } from "src/api/models";
import {
  preventLeadingSpaceKey,
  handlePasteWithoutLeadingSpaces,
  removeLeadingSpaces,
} from "../../../core/utils/input-validation.utils";
interface Plan {
  fid: string;
  issuerName: string;
  insiderName: string;
  relation: string;
  directIndirect: string;
  planAction: string;
  adoptionDate: string;
  effectiveDate: string;
  expirationDate: string;
  amendmentDate: string;
  terminationDate: string;
  security: string;
  transaction: string;
  shares: number;
  notionalValue: string;
  link: string;
}

interface PlansData {
  issuer: string;
  issuerId: number | string;
  plans: InsiderTradingPlans[];
}

@Component({
  selector: "app-insider-trading-plans",
  templateUrl: "./insider-trading-plans.component.html",
  styleUrls: ["./insider-trading-plans.component.css"],
  standalone: false,
})
export class InsiderTradingPlansComponent implements OnInit {
  @ViewChild("scrollContainer") scrollContainer!: ElementRef;
  filteredPlans: any[] = [];
  planActions = [
    { label: "All", value: "" },
    { label: "Adoption", value: "adoption" },
    { label: "Termination", value: "termination" },
    { label: "Amendment", value: "amendment" },
  ];

  tags = [
    { label: "Related", value: "related" },
    { label: "Award Related", value: "award-related" },
    { label: "Gift Related", value: "gift-related" },
    { label: "Tax Withheld", value: "tax-withheld" },
    { label: "Remuneration", value: "remuneration" },
  ];
  onApplyTags() {
    console.log("Apply Tags:", this.filters.tag);
    // you can add logic to tag selected records
  }
  filters: any = {
    fid: "",
    issuerName: "",
    insider: "",
    action: "",
    tag: "",
    indeterminable: false,
    announcementFrom: null,
    announcementTo: null,
    includeIndeterminable: false,
  };
  isFiltersActive(): boolean {
    const f = this.filters;
    return !!(
      f.fid ||
      f.issuerName ||
      f.insider ||
      f.action ||
      f.tag ||
      f.announcementFrom ||
      f.announcementTo ||
      f.indeterminable ||
      f.includeIndeterminable
    );
  }

  // Pagination for Insiders
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  filingDateFrom: Date | null = null;
  filingDateTo: Date | null = null;
  issuerWithInsiderTradingPlans: IssuerWithInsiderTradingPlans | null = null;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  plansData: PlansData[] = [];
  isLastPage = false;
  selectedInsiders: any[] = [];
  constructor(
    public dialogService: DialogService,
    public insiderTradingPlansService: InsiderTradingPlansService,
    public _messageService: MessageService,
    private router: Router
  ) {}
  getBadgeClass(action: string): string {
    switch (action) {
      case "adoption":
        return "badge badge-adoption";
      case "termination":
        return "badge badge-termination";
      case "amendment":
        return "badge badge-amendment";
      default:
        return "";
    }
  }
  onExecute() {
    console.log("Execute triggered with:", this.filters);
  }

  ngOnInit(): void {
    // this.getInsiderTradingPlans();
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    if (this.scrollContainer?.nativeElement) {
      this.scrollContainer.nativeElement.scrollTo({
        top: 0,
        behavior: "smooth", // smooth scroll effect
      });
    }
  }
  loadData(event?: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;

    this.getInsiderTradingPlans();
  }

  getInsiderTradingPlans(isLoadMore: boolean = false): void {
    const today = new Date();
    const fromDate = new Date("2024-10-25");
    const toDate = this.filingDateTo ?? today;

    // If issuerName is provided, exclude dates from payload
    // const hasIssuerNameFilter = this.filters.issuerName?.trim().length > 0;

    const issuerName = this.filters.issuerName.trim() || undefined;

    const params: InsiderTradingPlansFilters = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      issuerName,

      filingDateFrom: issuerName
        ? "" // must be empty string
        : this.formatDateForBackend(
            this.filters.announcementFrom
              ? this.filters.announcementFrom
              : fromDate
          ),

      filingDateTo: issuerName
        ? "" // must be empty string
        : this.formatDateForBackend(
            this.filters.announcementTo ? this.filters.announcementTo : toDate
          ),
    };

    this.isLoading = true;
    this.insiderTradingPlansService.getInsiderTradingPlans(params).subscribe({
      next: (value) => {
        this.issuerWithInsiderTradingPlans = value || [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        const newData = this.convertToPlans(this.issuerWithInsiderTradingPlans);
        const newGroups = this.convertToPlans(
          this.issuerWithInsiderTradingPlans
        );

        this.plansData = isLoadMore
          ? [...this.plansData, ...newGroups]
          : newGroups;
        this.paginator.totalCount =
          this.issuerWithInsiderTradingPlans?.IssuersWithFilingIds?.[0]
            ?.totalCount ?? 0;
        // Update isLastPage
        this.isLastPage =
          this.paginator.pageNumber * this.paginator.pageSize >=
          this.paginator.totalCount;
        console.log("plansData", this.plansData);
        this.isLoading = false;
      },
    });
  }

  convertToPlans(response: IssuerWithInsiderTradingPlans | null): PlansData[] {
    if (
      !response ||
      !response.IssuersWithFilingIds ||
      !response.insiderTradingPlans
    ) {
      return [];
    }

    const issuers = response.IssuersWithFilingIds;
    const plansList = response.insiderTradingPlans;

    // Build PlansData[] grouped by issuer
    // return issuers.map((issuer) => ({
    //   issuer: issuer.issuerName ?? "-",
    //   issuerId: issuer.issuerId ?? "",
    //   plans: plansList
    //     .filter((plan) => plan.issuerId === issuer.issuerId)
    //     .map((plan) => ({
    //       ...plan,
    //       relationType: plan.relationType ?? "-",
    //       adoptionDate: plan.adoptionDate ?? "-",
    //       effectiveDate: plan.effectiveDate ?? "-",
    //       expirationDate: plan.expirationDate ?? "-",
    //       amendmentDate: plan.amendmentDate ?? "-",
    //       terminationDate: plan.terminationDate ?? "-",
    //       security: plan.security ?? "-",
    //       Transaction: plan.Transaction ?? "-",
    //       nationalValue: plan.nationalValue ?? "-",
    //       asReportedSecurityBreakdownTags:plan.asReportedSecurityBreakdownTags,
    //       issuerStatus:plan.issuerStatus,
    //       tradingPlanStatus:plan.tradingPlanStatus
    //     })),
    // }));
    return issuers.map((issuer) => {
      const issuerPlans = plansList
        .filter((plan) => plan.issuerId === issuer.issuerId)
        .map((plan) => ({
          ...plan,

          // fields normal
          relationType: plan.relationType ?? "-",
          adoptionDate: plan.adoptionDate ?? "-",
          effectiveDate: plan.effectiveDate ?? "-",
          expirationDate: plan.expirationDate ?? "-",
          amendmentDate: plan.amendmentDate ?? "-",
          terminationDate: plan.terminationDate ?? "-",
          security: plan.security ?? "-",
          Transaction: plan.Transaction ?? "-",
          nationalValue: plan.nationalValue ?? "-",
          issuerStatus: plan.issuerStatus,
          tradingPlanStatus: plan.tradingPlanStatus,
          tradingPlanDuplicate: plan.tradingPlanStatus === "DUPLICATE",
          //  create a boolean flag for duplicate
          isDuplicate: plan.issuerStatus === "DUPLICATE",
        }));

      // issuer-level boolean: ANY plan duplicate?
      const issuerCheckDuplicate = issuerPlans.some((p) => p.isDuplicate);

      return {
        issuer: issuer.issuerName ?? "-",
        issuerId: issuer.issuerId ?? "",

        //  now you have clean boolean to use in table
        issuerDuplicate: issuerCheckDuplicate,
        plans: issuerPlans,
      };
    });
  }
  navigateToIssuer(group: PlansData): void {
    if (!group?.issuerId) {
      return;
    }
    this.router.navigate(["issuer-details"], {
      queryParams: { issuerId: group.issuerId, issuerName: group.issuer },
    });
  }
  onSubmitFilters(): void {
    this.paginator.pageNumber = 1;
    this.plansData = [];
    this.getInsiderTradingPlans(false);
  }
  clearFilters() {
    this.filters = {
      fid: "",
      issuerName: "",
      insider: "",
      action: "",
      tag: "",
      indeterminable: false,
      announcementFrom: null,
      announcementTo: null,
      includeIndeterminable: false,
    };
    this.onSubmitFilters();
  }
  // Format to backend expected: yyyy-MM-dd
  formatDateForBackend(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  onScrollDown() {
    // Triggered automatically when scrolled to bottom
    if (!this.isLastPage) {
      this.paginator.pageNumber++;
      this.getInsiderTradingPlans(true);
    }
  }
  onSelectionChange(event: any) {
    console.log("Selected Insiders:", event);
    console.log("SelectedInsiders array:", this.selectedInsiders);
  }
  getStringForTransactionTags(
    securityBreakDownTags: (keyof AsReportedSecurityBreakdownTags)[] | null
  ): string {
    if (!securityBreakDownTags) return "";

    const map: Record<keyof AsReportedSecurityBreakdownTags, string> = {
      awardRelated: "A",
      optionsRelated: "O",
      giftRelated: "G",
      taxWithheld: "T",
      remuneration: "R",
      isIndeterminable: "I",
      sellToCover: "S",
      asReportedSecurityBreakdownId: "",
      modified: "",
    };

    return securityBreakDownTags.map((tag) => map[tag]).join(" ");
  }
  preventSpaceKey(event: KeyboardEvent): void {
    // Use generic utility function to prevent leading spaces
    preventLeadingSpaceKey(event);
  }

  onPaste(event: ClipboardEvent): void {
    // Use generic utility function to handle paste without leading spaces
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this.filters.issuerName = newValue;
    });
  }

  onIssuerNameBlur(): void {
    // Remove leading spaces using utility function
    this.filters.issuerName = removeLeadingSpaces(this.filters.issuerName);
  }
}
